import React from 'react';
import {
  replaceLocation,
} from '../../../../router';

import withState from '../../../../utils/withState';
import {account$} from '../../../../emitters/account';
import {USER_TYPE_MERCHANT} from '../../../../constants';
import {LINK_DEVELOPER_OPTIONS} from '../../../../constants/links';

module.exports = withState(() => {
  return (state, props) => {

    const account = state.account;

    const redirectLinks = {
      [USER_TYPE_MERCHANT]: LINK_DEVELOPER_OPTIONS,
      // [USER_TYPE_CUSTOMER]: LINK_TRANSACTIONS,
    };

    const redirectLink = account && redirectLinks[account.console_role] || '';

    if (!redirectLink) return <span />;

    replaceLocation({
      path: redirectLink,
    });

    return <span />;
  };
}, {
  account: account$,
});
